export default __webpack_public_path__ + "static/media/CookiesOreo.91f82792.png";